import { Injectable, inject } from '@angular/core';
import { BookingDocumentModel, DocumentService, DocumentTypeModel } from '@railmybox/api-booking';

@Injectable()
export class UploadDocManagementService {
  private documentsService = inject(DocumentService);

  getDocuments(bookingRef: string, documentType: DocumentTypeModel, containerKey?: string): Promise<BookingDocumentModel[]> {
    if (containerKey) {
      return this.documentsService.getBookingContainerDocumentDetails(bookingRef, containerKey, [documentType]).toPromise();
    } else {
      return this.documentsService.getBookingDocumentDetails(bookingRef, [documentType]).toPromise();
    }
  }
}
